import { loading_icon } from './../vars/loading_icon.js';
import { api } from './../function/api.js';
import { trigger_date_picker, start_loading, end_loading } from './../function/common.js';
import { notification } from './../function/notification.js';
import { Trip, Cart, Editor } from './../classes.js';

document.addEventListener("DOMContentLoaded", function() {
	//set the loading icon to anything that might be delayed
	$('.loading').html(loading_icon);
	$('.loading').removeClass('loading');
	
	
	/*** BODY LISTENER TO CLOSE ACTIVE SYSTEMS ***/
	$('body').on('click', function(e){
		
		//close trip view menu
		if(!$(e.target).closest('.trip__display_mode').length){
			$('.trip__display_mode').removeClass('active');
		}
		//close trip view menu
		if(!$(e.target).closest('.trip__filter_mode').length){
			$('.trip__filter_mode').removeClass('active');
		}
		
		if(!$(e.target).closest('.active_listener').hasClass('active')){
			if($(e.target).closest('.active_target').length == 0){
				Trip.close_trip_toolbar();
				Editor.close_elements_menu();
			}
		}
		
	});
	$('body').on('click', '.btn--close', function(e){
		$(this).closest('.lightbox').fadeOut(200);
	});
	
	
	/*** ACCORDION HANDLER ***/
	$('body').on('click', '.accordion .accordion__trigger', function(e){
		let wrapper = $(this).closest('.accordion');
		let trigger = $(this);
		let content = $(this).siblings('.accordion__content');
		
		if(wrapper.hasClass('accordion--closed')){
			wrapper.removeClass('accordion--closed');
		}else{
			wrapper.addClass('accordion--closed');
		}
		
	});
	
	/*** STEPS HANDLER ***/
	$('body').on('click', '.step', function(e){
		
		if($(this).is('[data-step]')){
			let target = $(this).attr('data-step');
			$('.step').removeClass('active');
			$(this).addClass('active');
			
			$('.step-target').hide();
			$(`.step-target[data-target="${target}"]`).show();
		}
		
	});
	let step_i = 1;
	let step_count = $('.step').length;
	if(step_count > 0){
		while (step_i <= step_count) {
			if(!$(`.step[data-step="${step_i}"]`).hasClass('complete')){
				$(`.step[data-step="${step_i}"]`).addClass('active');
				$(`.step[data-step="${step_i}"]`).click();
				break;
			}
			step_i++;
		}
	}
	
	
	/*** ACTIVE SYSTEM TRIGGER HANDLER ***/
	$('body').on('click', '.active_listener', function(e){
		e.preventDefault();
		
		let $trigger = $(this);
		let $target = $(this).siblings('.active_target');
		
		if($trigger.hasClass('active')){
			$('.active_listener').removeClass('active');
			$('.active_target').removeClass('active');
		}else{
			$('.active_listener').removeClass('active');
			$('.active_target').removeClass('active');
			
			$trigger.addClass('active');
			$target.addClass('active');
		}
		
	});
	
	
	/*** CARD LINKS ***/
	$('body').on('click', '.card', function(e){
		
		if($(this).is('[data-link]')){
			let target = $(this).attr('data-link');
			
			window.location.href = target;
		}
	});
	
	/*** UNIQUE CARD INTERACTIONS ***/
	$('body').on('click', '.card_menu__icon', function(e){
		e.stopPropagation(); 
		
		let $target = $(this).siblings('.card_menu__options');
		
		if($target.hasClass('active')){
			$target.removeClass('active');
		}else{
			$target.addClass('active');
		}
	});
	$('body').on('click', '.card_menu__options li', function(e){
		e.stopPropagation(); 
		
		switch($(this).data('action')){
			case 'edit':
				let target = $(this).attr('data-target');
				window.location.href = target;
				break;
			case 'delete':
				confirm_target_delete($(this).attr('data-target'), $(this).attr('data-additional'));
				break;
		}
		
	});
	function confirm_target_delete(id, name, type="trip"){
		$('.lb_td_type').text(type);
		$('.lb_td_name').text(name);
		$('.lb_td_type_val').val(type);
		$('.lb_td_id_val').val(id);
		$('.lb_td_id_val').attr('name', `${type}_id`);
		$('#target_delete').attr('action', `/api/${type}/delete`);
		
		$('#lightbox_target_delete').css("display", "flex").hide().fadeIn(200);
	}
   
   	/*** DATEPICKER HANDLER ***/
	trigger_date_picker();
	
	
	/*** FORM HANDLER ***/
	$('body').on('submit', 'form', async function(e){
		e.preventDefault();
		//e.data.obj //contains 'this' for the object
		if($(this).is('.form--search')){
			return false;
		}
		
		start_loading('Processing...');
		
		//get this form and response elements
		const this_form = e.target.closest('form');
		let data = new FormData(this_form);
		const this_response = this_form.querySelector('.response');
		const this_action = this_form.action;
		const this_success = this_form.dataset.success;
		let token = 'Jaxbend API Verified Action';
		
		//if this is a public URL, we should verify the action via Captcha
		switch(true){
			case this_action.includes('/account/signup'):
				token = await grecaptcha.enterprise.execute('6LfF89UtAAAAAEmzq0Gl3VxpmCytFJhyVH2S52bA', {action: 'SIGNUP'});
				break;
				
			case this_action.includes('/contact'):
				token = await grecaptcha.enterprise.execute('6LfF89UtAAAAAEmzq0Gl3VxpmCytFJhyVH2S52bA', {action: 'CONTACT'});
				break;
		}
		
		data.append('g-recaptcha-response', token);
		
		//reset the form to it's base state
		if(this_response){
			this_response.classList.remove('response--error');
			this_response.classList.remove('response--success');
			this_response.textContent = '';
		}
		
		//post
		let response = await api(this_action, data);
		console.log('*** API RESPONSE');
		console.log(response);
		end_loading('Complete');
		
		//response
		if(response){
			
			
			if(response.error){
				if(this_response){
					this_response.classList.add('response--error');
					this_response.textContent = response.message.join('\n');
				}
				
				notification(response.message.join('<br/>'));
			}else{
				if(this_success == 'reload'){
					location.reload();
				}else if(this_success == 'stay'){
					//do not navigate, display any messages though
					if(Object.keys(response.message).length > 0){
						if(this_response){
							this_response.classList.add('response--success');
							this_response.textContent = response.message.join('\n');
						}
						
						notification(response.message.join('<br/>'));
					}
					
					if($(this).is('.add_to_cart')){
						Cart.added_to_cart($(this));
					};
				}else{
					if(response.data.redir){
						window.location.href = response.data.redir;
					}else{
						window.location.href = this_success;
					}
				}
			}
		}
	});
	
	
	/*** LOGOUT HANDLER ***/
	$('body').on('click', '.logout', async function(e){
		e.preventDefault();
		
		//post
		let response = await api('/logout');
		
		location.reload();
	});
	
	
	/*** TRIP VIEW SELECTOR ***/
		//Open View Selector
	$('body').on('click', '.trip__display_mode', function(e){
		e.preventDefault();
		
		if($(this).hasClass('active')){
			$(this).removeClass('active');
		}else{
			$(this).addClass('active');
		}
	});
		//New View and Close Menu
	$('body').on('click', '.trip__display_mode.active .trip__display_options li', async function(e){
		e.preventDefault();
		let prev_view = $('.trip__display_mode.active .trip__display_options li.active').data('view');
		$('.trip__display_mode.active .trip__display_options li').removeClass('active');
		$(this).addClass('active');
		
		if(prev_view == 'author' || prev_view == 'full-edit' || prev_view == 'publish'){
			await Trip.save();
		}
		Trip.render_view($(this).data('view'));
	});
	
	
	/*** TRIP FILTER SELECTOR ***/
		//Open Filter Selector
	$('body').on('click', '.trip__filter_mode', function(e){
		e.preventDefault();
		
		if($(this).hasClass('active')){
			$(this).removeClass('active');
		}else{
			$(this).addClass('active');
		}
	});
		//New View and Close Menu
	$('body').on('click', '.trip__filter_mode.active .trip__filter_options li', function(e){
		e.preventDefault();
		
		$('.trip__filter_mode.active .trip__filter_options li').removeClass('active');
		$(this).addClass('active');
		
		Trip.render_filter($(this).data('filter'));
	});
	
	
	/*** GALLERY HANDLER ***/
	$('body').on('click', '.media__has_gallery img', async function(e){
		e.preventDefault();
		e.stopPropagation();
		let $target = $(this).closest('.e');
		
		//reset the display
		$('#lb_gallery_content').html('');
		
		//add gallery images
		$target.find('img').each(function(index, element) {
			$('#lb_gallery_content').append($(this).clone());
		});
		
		//open lightbox
		$('#lightbox_gallery').css("display", "flex").hide().fadeIn(200);
	});
	
	
	/*** LIGHTBOX HANDLER ***/
	$('body').on('click', '.lightbox, .lightbox--close', async function(e){
		e.preventDefault();
		e.stopPropagation();
		
		$('.lightbox').fadeOut(200);
	});
	$('body').on('click', '.lightbox > div, .lightbox > form', async function(e){
		e.stopPropagation();
	});
	
	
	/*** SLIDER HANDLER ***/
	$('body').on('click', '.card__slider_nav', async function(e){
		e.preventDefault();
		e.stopPropagation();
		
		let $target = $(this).parent('.card__slider_wrapper');
		
		//mobile slider handler (max-height adjustment)
		if(window.is_mobile){
		
			//get key details of cards and widths
			let m_position = parseInt($target.find('.card__slider_content').css('max-height') ? $target.find('.card__slider_content').css('max-height') : 0);
			let m_adjustment = $target.find('.card__slider_content .card').first().height();
			let m_margin = parseInt($target.find('.card__slider_content .card').first().css('margin-bottom'));
			let m_max_adjust = (($target.find('.card__slider_content')[0].scrollHeight + 52));
			
			//if this can be clicked, process it
			if($(this).hasClass('active')){
				let m_set_position = 0;
				
				//determine the direction to adjust the view
				if($(this).hasClass('card__slider_nav--next')){
					m_set_position = m_position + ((m_adjustment + m_margin + 24) * 2);
				}
				
				//if our new position goes beyond the width of the viewbox, disable the forward button
				if(m_set_position >= m_max_adjust){
					m_set_position = m_max_adjust;
					$target.find('.card__slider_nav--next').fadeOut(500);
					$target.find('.card__slider_nav--next').removeClass('active');
				}
				
				
				$target.find('.card__slider_content').animate({
					maxHeight: m_set_position,
				}, 300);
			}
		
		
		//desktop slider handler (left adjustment)		
		}else{
			//get key details of cards and widths
			let position = parseInt($target.find('.card__slider_content').css('left') ? $target.find('.card__slider_content').css('left') : 0);
			let adjustment = $target.find('.card__slider_content .card').first().width();
			let margin = parseInt($target.find('.card__slider_content .card').first().css('margin-right'));
			let max_adjust = (($target.find('.card__slider_content')[0].scrollWidth + 52) - $target.find('.card__slider').width()) * -1; //set to negative since we adjust left to a negative number
			
			//if this can be clicked, process it
			if($(this).hasClass('active')){
				let set_position = 0;
				
				//determine the direction to adjust the view
				if($(this).hasClass('card__slider_nav--prev')){
					set_position = position + ((adjustment + margin + 24) * 2);
				}
				if($(this).hasClass('card__slider_nav--next')){
					set_position = position - ((adjustment + margin + 24) * 2);
				}
				
				//if our new position is negative, enable the backwards button
				if(set_position >= 0){
					set_position = 0;
					$target.find('.card__slider_nav--prev').fadeOut(500);
					$target.find('.card__slider_nav--prev').removeClass('active');
				}else{
					$target.find('.card__slider_nav--prev').fadeIn(500);
					$target.find('.card__slider_nav--prev').addClass('active');
				}
				
				//if our new position goes beyond the width of the viewbox, disable the forward button
				if(set_position <= max_adjust){
					set_position = max_adjust;
					$target.find('.card__slider_nav--next').fadeOut(500);
					$target.find('.card__slider_nav--next').removeClass('active');
				}else{
					$target.find('.card__slider_nav--next').fadeIn(500);
					$target.find('.card__slider_nav--next').addClass('active');
				}
				
				
				$target.find('.card__slider_content').animate({
					left: set_position,
				}, 300);
			}
		}
	});
	
		//ADMIN Listeners
	$('body').on('click', '.admin_action', async function(e){
		e.preventDefault();
		
		let trip_id = $(this).closest('tr').attr('data-trip');
		let action = $(this).hasClass('admin_action--confirm') ? 'approved' : 'rejected';
		let review_form = new FormData();
		review_form.append('trip_id', trip_id);
		review_form.append('action', action);
		
		try {
			let response = await fetch('/api/admin/review', {
				method: 'POST',
				body: review_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				//error
			}else{
				$(`tr[data-trip="${trip_id}"]`).fadeOut(400, function() {
					$(`tr[data-trip="${trip_id}"]`).remove();
				});
			}
			
		} catch (error) {
			console.error('Error ***', error);
		}
	});
});